module.exports = __webpack_public_path__ + "img/spinneys-original-480.0168cb37.png";